import { render } from "./InputPrice.vue?vue&type=template&id=d3a43a64&scoped=true"
import script from "./InputPrice.vue?vue&type=script&lang=js"
export * from "./InputPrice.vue?vue&type=script&lang=js"

import "./InputPrice.vue?vue&type=style&index=0&id=d3a43a64&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a43a64"]])

export default __exports__